<app-header></app-header>
<main class="timeapp">
	
	<div class="page-wrapper">
		
		<div style="display: flex; flex-direction: row; position: relative; width: 100%; justify-content: center;">
			<div style="position: absolute; right: 0; top: 0; display: flex;">
				<mat-icon (click)="showDailyNotes()" *ngIf="displayabledNotes.length > 0 && scheduleObj!.activeView.renderDates.length > 1" style="font-size: 3em; height: 1em; width: 1em;">info
				</mat-icon>
			</div>
			<mat-form-field appearance="outline" style="width: auto;">
				<mat-label>{{ "HOME.Mitarbeiter wählen" | translate }}</mat-label>
				<mat-select [formControl]="formValue">
					<mat-option *ngFor="let item of IndexedDbData?.allEmployees" [value]="item.employeeID">
						{{ item.firstName }} {{ item.lastName }}
					</mat-option>
				</mat-select>
			</mat-form-field>
			<div style="position: absolute; left: 0; top: 0; display: flex;">
				<mat-icon (click)="showEmployeeNote()" *ngIf="workerNote" [matTooltip]="workerNote" style="color: rgb(199, 34, 41); font-size: 3em; height: 1em; width: 1em;">info_outline</mat-icon>
			</div>
		</div>
		<div style="font-size: 1.25em; padding: 0.25em 0;">
			<span *ngIf="displayabledNotes.length == 1 && scheduleObj!.activeView.renderDates.length == 1" style=" word-break: break-word; text-align: center; width: 100%; display: block;">
				{{ displayabledNotes[0]['Note'] }}
			</span>
		</div>
		
		<div style="min-height:200px">
			<ejs-schedule #scheduleObj (eventClick)="picked($event)" (popupOpen)="onPopupOpen($event)" [(currentView)]="setView" [dateFormat]="dateFormat" [endHour]="endHour"
			              (eventRendered)="onEventRendered($event)" [eventSettings]="eventSettings" [selectedDate]="selectedDate!" [startHour]="startHour" [timeFormat]="timeFormat" height="100%"
			              style="min-height: 400px" width="100%">
				<ng-template #eventSettingsTemplate let-data>
					<div style="display: flex; flex-direction: column; padding: 4px;">
						<span class="first-row">
							<span class="title">{{ data.Subject }} | {{ getTimeString(data.StartTime) }} - {{ getTimeString(data.EndTime) }}</span>
							<span (click)="showDetails($event, data)" class="btn info-btn">
								<fa-icon [icon]="faA" size="xs" style="color: white"></fa-icon>
							</span>
						</span>
						<div>
							<span *ngIf="data.projectLeader">{{ "MAIN_APP_TIME.SHARE_ORDER.projectLeader" | translate }}: {{ data.projectLeader }} </span>
							<span *ngIf="data.Location">{{ data.Location }}</span>
							<span *ngIf="data.Name"> | {{ data.Name }} </span>
							<span *ngIf="data.Phone"> | {{ data.Phone }} </span>
							<span *ngIf="data.AnspPhone"> | {{ data.AnspPhone }} </span>
		
						</div>
						<span *ngIf="data.Category">{{ data.Category.description }}</span>
						<span *ngIf="data.Notes" [innerText]="data.Notes" style="word-break: break-word; font-weight: bold"></span>
					</div>
				</ng-template>
			</ejs-schedule>
		</div>
	
	</div>

</main>
<footer class="mobile timeapp">
	<mat-icon (click)="goBack()">
		arrow_back
	</mat-icon>
</footer>
